/**
 * Получает название подкатегории объекта по его subcategoryId
 * @param {Array} categories - Массив категорий из objectStore
 * @param {number} subcategoryId - ID подкатегории объекта
 * @returns {string} Название подкатегории или пустая строка, если не найдено
 */
export const getObjectTypeName = (categories, subcategoryId) => {
  if (!categories || !subcategoryId) return '';
  
  for (const category of categories) {
    if (!category.subcategories) continue;
    
    const subcategory = category.subcategories.find(
      sub => parseInt(sub.id) === parseInt(subcategoryId)
    );
    
    if (subcategory) {
      return subcategory.name;
    }
  }
  
  return '';
};

/**
 * Преобразует тип сделки в человекочитаемый формат на основе _mainDealType
 * @param {Object} details - Детали объекта, содержащие поле _mainDealType
 * @returns {string} Человекочитаемый тип сделки
 */
export const getDealTypeName = (details) => {
  if (!details || !details._mainDealType) return '';
  
  switch (parseInt(details._mainDealType)) {
    case 1:
      return 'Продажа';
    case 2:
      return 'Аренда';
    default:
      return '';
  }
};

/**
 * Получает тип аренды в человекочитаемом формате
 * @param {Object} details - Детали объекта
 * @returns {string} Тип аренды или пустая строка, если не применимо
 */
export const getRentTypeName = (details) => {
  if (!details || !details._rent_type) return '';
  
  switch (details._rent_type) {
    case 1:
      return 'Долгосрочная';
    case 2:
      return 'Посуточная';
    default:
      return '';
  }
};

/**
 * Формирует полную информацию об объекте недвижимости
 * @param {Object} object - Объект недвижимости
 * @param {Array} categories - Массив категорий из objectStore
 * @returns {string} Строка с информацией об объекте
 */
export const getObjectFullInfo = (object, categories) => {
  if (!object || !categories) return '';
  
  const typeName = getObjectTypeName(categories, object.subcategoryId);
  
  if (!object.details) return typeName;
  
  const dealTypeName = getDealTypeName(object.details);
  
  let result = typeName;
  
  if (dealTypeName) {
    result += `. ${dealTypeName}`;
    
    // Добавляем информацию о типе аренды, если это аренда
    if (parseInt(object.details._mainDealType) === 2) {
      const rentTypeName = getRentTypeName(object.details);
      if (rentTypeName) {
        result += `. ${rentTypeName}`;
      }
    }
  }
  
  return result;
}; 